import React, { Component } from "react";
import Switch from "react-switch";

class FailPass extends Component {
	constructor(props){
		super(props);
	}
	render(){
		return(
			<Switch 
				checked={this.props.checked}
				onChange={this.props.handleChange}
				width={65}
				height={25}
				disabled={this.props.disabled}
				uncheckedIcon={
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
							fontSize: 15,
							color: "#fff",
							paddingRight: 2
						}}
					>
						Fail
					</div>
				}
				checkedIcon={
					<div
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
							fontSize: 15,
							color: "#fff",
							paddingLeft: 5
						}}
					>
						Pass
					</div>
				}
			/>
		);
	}
}

export default FailPass;